export type Source = "web" | "mini";

export const EVENTS = {
  LOGIN: "login",
  REGISTER: "register",
  SEARCH: "search",
  IMAGE_SEARCH: "image_search",
  ADD_TO_CART: "add_to_cart",
  CHECKOUT_SUBMIT: "checkout_submit",
  PAYMENT_START: "payment_start",
  ORDER_PAID: "order_paid",
} as const;

export type EventName = (typeof EVENTS)[keyof typeof EVENTS];

export type AuthMethod = "email" | "yandex" | "tg";
export type ImageSearchSource = "upload" | "paste" | "camera";

export type EventParamsMap = {
  login: { method: AuthMethod };
  register: { method: AuthMethod };
  search: { query: string; results_count: number };
  image_search: { source: ImageSearchSource; results_count: number };
  add_to_cart: { spuNo: string; channel: string; price_kop: number; qty: number };
  checkout_submit: { order_id: string; item_count: number; subtotal_kop: number };
  payment_start: { order_id: string; method: string; amount_kop: number };
  order_paid: { order_id: string; revenue_kop: number; currency: "RUB" };
};

export type EventParams<N extends EventName> = EventParamsMap[N];

export type MetricaOptions = {
  webvisor?: boolean;
  clickmap?: boolean;
  trackLinks?: boolean;
  accurateTrackBounce?: boolean;
};
